<div class="modal-header">
  <h4 class="modal-title h5">
    <div [innerHTML]="subject"></div>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div [innerHTML]="message"></div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary"
          (click)="onCancel()">
    <span translate>Close</span>
  </button>

</div>
